import Header from "@/components/header";
import { updateMerchantInfoPayload } from "@/models/payload/profile";
import {
  Box,
  Button,
  Container,
  Grid,
  LoadingOverlay,
  Stack,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";

import * as Yup from "yup";

import { useAuth } from "@/context/auth";
import useIsSmall from "@/hooks/useIsSmall";
import { useGetMerchantForMerchantUser } from "@/services/merchant/utilities";
import useUpdateMerchant from "../../hooks/useUpdateMerchant";

const signUpSchema = Yup.object({
  firstName: Yup.string().required("وارد کردن نام الزامی است."),
  lastName: Yup.string().required("وارد کردن نام خانوادگی الزامی است."),
});

function EditInformationProfile() {
  const isSmall = useIsSmall();
  const { getUserByToken } = useAuth();

  const { data: merchantUser, isLoading } = useGetMerchantForMerchantUser(
    getUserByToken()?.phoneNumber ?? ""
  );

  // const user = merchantUser as MerchantUserDto;
  const { updateMerchant, isLoading: submitLoading } = useUpdateMerchant();
  const form = useForm<updateMerchantInfoPayload>({
    validate: yupResolver(signUpSchema),
    initialValues: {
      firstName: merchantUser?.firstName,
      lastName: merchantUser?.lastName,
      // nationalCode: data?.nationalCode,
    },
  });
  const { setValues } = form;
  useEffect(() => {
    setValues({
      firstName: merchantUser?.firstName,
      lastName: merchantUser?.lastName,

      // nationalCode: data?.nationalCode,
    });
  }, [merchantUser, setValues]);

  const submit = (values: updateMerchantInfoPayload) => {
    updateMerchant(values);
  };

  return (
    <>
      <Header showBack title="اطلاعات کسب و کار" />
      <Container>
        <Stack mih="100%">
          <Stack flex={1}>
            <Stack flex={1} px="md">
              <Title order={4}>اطلاعات فردی</Title>
              <LoadingOverlay visible={isLoading} />
              <Box>
                <form id="information" onSubmit={form.onSubmit(submit)}>
                  <Grid>
                    <Grid.Col span={{ base: 12 }}>
                      <TextInput
                        size="lg"
                        withAsterisk
                        label="نام"
                        styles={{
                          label: {
                            fontSize: "1rem",
                          },
                        }}
                        {...form.getInputProps("firstName")}
                      />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12 }}>
                      <TextInput
                        size="lg"
                        withAsterisk
                        styles={{
                          label: {
                            fontSize: "1rem",
                          },
                        }}
                        label="نام خانوادگی"
                        {...form.getInputProps("lastName")}
                      />
                    </Grid.Col>
                    <Grid.Col span={{ base: 12 }}>
                      {/* <InputBase
                      size="md"
                      type="tel"
                      dir="ltr"
                      styles={{
                        input: {
                          textAlign: "left",
                          paddingLeft: "16px",
                        },
                      }}
                      value={form.values.nationalCode || ""}
                      maxLength={11}
                      label="کد ملی"
                      withAsterisk
                      onChange={(e) => {
                        form.setValues({
                          nationalCode: PersianUtil.currentNumberToEnglish(
                            e.target.value
                          ),
                        });
                      }}
                      error={form.errors.nationalCode}
                    /> */}
                    </Grid.Col>
                  </Grid>
                </form>
              </Box>
            </Stack>
            <Stack px="md" mb="lg">
              <Button
                type="submit"
                form="information"
                size="md"

                loading={submitLoading}
                w={isSmall ? "100%" : "150px"}
              >
                ثبت تغییرات
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}

export default EditInformationProfile;
